import * as types from './types/mutations';
export default {
    [types.SHOW_POPUP](state) {
        state.showPopup = true;
    },
    [types.CLOSE_POPUP](state) {
        state.showPopup = false;
    },
    [types.ADD_BOOKING](state, booking) {
        state.bookings = [
            ...state.bookings,
            Object.assign({}, booking),
        ];
    },
};



// WEBPACK FOOTER //
// ./src/core/store/bookings/mutations.ts